import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/navigation/web/Navbar";
import { ExecuteModule } from "../../components/Execute/ExecuteModule";

const Execute = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("sim_masive.title"),
					component: <ExecuteModule />,
				}}
				right={null}
			/>
		</>
	);
};

export { Execute };
